// ── Javítási ársávok – EGY forrás-igazság (Sprint 1.1 / FELADAT 3) ──────────
// A landing/szerviz oldalak „már X Ft-tól” sávjai innen jönnek. A szabály:
//
//   • Ha VAN valódi, ismert minimum ár → „<Szolgáltatás> már XX XXX Ft-tól”
//   • Ha NINCS → „Kérj személyre szabott ajánlatot”
//
// SOHA nem találunk ki árat. A `null` érték tudatos: azt jelenti, hogy az adott
// javításra jelenleg NINCS rögzített minimum ár a rendszerben. Amint van, elég
// ITT beírni a számot – a szöveg és a Service/Offer schema automatikusan
// megjelenik mindenhol, ahol a sáv ki van rakva.
//
// FONTOS: a felvásárlási (kalkulátor) árak NEM javítási árak – azokat tilos
// ide átemelni, mert az ügyfélnek fizetendő összeg és a javítás díja két
// különböző dolog.

/** Ismert minimum árak (HUF, bruttó). null = nincs adat → ajánlatkérés. */
export const REPAIR_MIN_PRICES = {
  screen: {
    // iPhone: a /szerviz árlistából a legolcsóbb tétel (iPhone SE 2020, utángyártott).
    iphone: 20000,
    // Samsung/Xiaomi kijelző: az alkatrészárak napi ingadozása miatt jelenleg
    // NINCS rögzített minimum a rendszerben → ajánlatkérő szöveg megy ki.
    samsung: null,
    xiaomi: null,
  },
  battery: {
    iphone: 20000,
    samsung: 13000,   // a Samsung/Xiaomi akkumulátorcsere-oldal élő ára
    xiaomi: 13000,
  },
};

/** Szolgáltatás-nevek a sáv szövegéhez. */
export const REPAIR_LABELS = {
  screen: 'Kijelzőcsere',
  battery: 'Akkumulátorcsere',
};

/** Ismert minimum ár lekérése. Ismeretlen szolgáltatás/márka → null. */
export const getRepairMinPrice = (service, brand) => {
  const byService = REPAIR_MIN_PRICES[service];
  if (!byService) return null;
  const value = byService[String(brand || '').toLowerCase()];
  return typeof value === 'number' && value > 0 ? value : null;
};

/** Ft-formázás magyar ezres tagolással („20 000 Ft”). */
export const formatHuf = (value) => `${Number(value).toLocaleString('hu-HU')} Ft`;

/** A megjelenítendő ársáv-szöveg (a FELADAT 3 által előírt két változat). */
export const repairPriceBandText = (service, brand) => {
  const min = getRepairMinPrice(service, brand);
  if (min === null) return 'Kérj személyre szabott ajánlatot';
  return `${REPAIR_LABELS[service] || 'Javítás'} már ${formatHuf(min)}-tól`;
};

/** Schema.org Offer node – CSAK ismert árnál. Ismeretlennél `undefined`, hogy
 *  a Service schema-ba ne kerüljön ki nem található / kitalált ár. */
export const repairOfferNode = (service, brand) => {
  const min = getRepairMinPrice(service, brand);
  if (min === null) return undefined;
  const price = String(min);
  return {
    '@type': 'Offer',
    priceCurrency: 'HUF',
    price,
    availability: 'https://schema.org/InStock',
    priceSpecification: { '@type': 'PriceSpecification', priceCurrency: 'HUF', minPrice: price },
  };
};
